// extracted by mini-css-extract-plugin
export default {"informationBlock":"InformationBlock_informationBlock__e9VBb","logoWithHeader":"InformationBlock_logoWithHeader__NKY4G","signUpButton":"InformationBlock_signUpButton__fgSqm"};